import * as config from "../config"

export default async function isUsernameAvailable(
	name: string,
): Promise<boolean> {
	const res = await fetch(`${config.API_HOSTNAME}/api/username_available`, {
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify({ name }),
	})
	const json = await res.json()

	return json.unique
}
